import axios from "axios";

const API_URL = process.env.VUE_APP_URL;

const getICD10List = async () => {
    try {
        const response = await window.axios.get(API_URL + '/icd10');
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getSuggestions = async (diagnoses) => {
    try {
        const url = `${String(process.env.VUE_APP_URL).replace('/api/v1', '')}/ai/claude/icd10/suggestion`;
        const response = await window.axios.post(url, {
            diagnoses: diagnoses
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    getICD10List,
    getSuggestions,
};
